/**
 * Arabic for the file-saving notices. Proposed; pending native review.
 *
 * These are only ever seen when a save could NOT happen, so they say what
 * did not occur before they say why — a person who has just pressed EXPORT
 * needs to know first that nothing was downloaded.
 */
const ar: Record<string, string> = {
  "This copy of the platform cannot save files, so {filename} was not downloaded. Open the platform itself, or ask for the file from the desk it came from.":
    "هذه النسخة من المنصة لا يمكنها حفظ الملفات، ولم يُنزَّل {filename}. افتح المنصة نفسها، أو اطلب الملف من المكتب الذي صدر عنه.",
  "{filename} is not a kind of file this viewer will save.": "{filename} ليس من أنواع الملفات التي يحفظها هذا العارض.",
  "{filename} is too large for this viewer to save.": "{filename} أكبر من أن يحفظه هذا العارض.",
  "Another download is already waiting for an answer. Finish that one first.":
    "هناك تنزيل آخر ما زال بانتظار الرد. أنهِ ذاك أولاً.",
  "{filename} could not be saved here.": "تعذّر حفظ {filename} هنا.",
  "{filename} could not be read to save.": "تعذّرت قراءة {filename} لحفظه.",
};

export default ar;
